import React, {CSSProperties} from 'react';
import {AssetMetaInterface} from '@taopix/taopix-core/dist/types/types';
import MaskThumbnail from './MaskThumbnail';

type MaskListProps = {
  masks: AssetMetaInterface[];
  orientation: 'vertical' | 'horizontal';
  columns: number;
  columnGap?: number;
  onClick: (maskAsset: AssetMetaInterface) => void;
  selectedMaskAsset: AssetMetaInterface | null;
};

const MasksList = ({
  masks,
  orientation,
  columns,
  columnGap,
  onClick,
  selectedMaskAsset,
}: MaskListProps) => {
  // Tailwind classes for the UL
  const thumbnailListClasses = [
    'flex',
    'w-[calc(100%+var(--gap))]',
    'self-start',
    'items-start',
    'flex-wrap',
    '-mt-[var(--gap)]',
    '-ml-[var(--gap)]',
  ];

  const cssProperties = {'--columns': columns, '--gap': columnGap + 'rem'};

  return (
    <ul className={thumbnailListClasses.join(' ')} style={cssProperties as CSSProperties}>
      {masks &&
        masks.map((mask: AssetMetaInterface, index: number) => {
          return (
            <MaskThumbnail
              mask={mask}
              key={`mask-${mask.assetRef}-${index}`}
              columns={columns}
              columnGap={columnGap}
              onClick={onClick}
              checked={mask.assetRef === selectedMaskAsset?.assetRef}
            />
          );
        })}
    </ul>
  );
};

export default MasksList;
